var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "person"
  }, [_c('a', {
    staticClass: "person-link",
    attrs: {
      "href": _vm.person.url
    }
  }, [_vm._v("\n    View Profile\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "avatar-wrap",
    class: _vm.badge_class
  }, [_c('img', {
    staticClass: "avatar-bg cm_bg",
    attrs: {
      "src": _vm.person.avatar || _vm.avatar,
      "alt": _vm.fullName,
      "loading": "lazy"
    }
  }), _vm._v(" "), (_vm.person.chapter) ? _c('ChapterBox', {
    attrs: {
      "chapter": _vm.person.chapter,
      "badge": _vm.person.team_badge
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "person-text"
  }, [_c('h1', {
    staticClass: "person-name"
  }, [_vm._v(_vm._s(_vm.fullName))]), _vm._v(" "), (_vm.description) ? _c('p', {
    staticClass: "person-description"
  }, [_vm._v("\n      " + _vm._s(_vm.description) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.person.location) ? _c('div', {
    staticClass: "person-location"
  }, [_vm._v(_vm._s(_vm.person.location))]) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-620516f1","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/individual-card.vue
// module id = null
// module chunks = 